import * as React from "react";
import { UnlinkedApplicationStatus, setPostedCompletedApplication, updateStatus, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { completedHomeUnlinkedApplication, completedUnlinkedApplication, } from "../../../lib/Avo";
import UnlinkedApplicationPolicyHolder from "../../../features/unlinked-application/routes/policy-holder";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useEffectOnceWhen } from "rooks";
import { useHistory } from "react-router-dom";
import usePostUnlinkedAccount from "../../../services/savvy/usePostUnlinkedAccount";
import useUnlinkedApplicationCompleteNextRoute from "../../../features/unlinked-application/useUnlinkedApplicationCompleteNextRoute";
export default function HomeUnlinkedApplicationPolicyHolder() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var history = useHistory();
    var status = useAppSelector(function (state) { return state.unlinkedApplication.status; });
    var nextRoute = useUnlinkedApplicationCompleteNextRoute("homeowners");
    var _a = usePostUnlinkedAccount(), postUnlinkedAccount = _a.postUnlinkedAccount, isLoading = _a.status.isLoading;
    var dispatch = useAppDispatch();
    function handleSubmit() {
        dispatch(updateStatus({ home: UnlinkedApplicationStatus.Complete }));
    }
    useEffectOnceWhen(function () {
        postUnlinkedAccount(function () {
            dispatch(setPostedCompletedApplication({ home: true }));
            completedUnlinkedApplication(commonAnalyticsProperties);
            completedHomeUnlinkedApplication(commonAnalyticsProperties);
            history.push(nextRoute);
        }, true);
    }, status.home === UnlinkedApplicationStatus.Complete);
    return (React.createElement(UnlinkedApplicationPolicyHolder, { onSubmit: handleSubmit, disableSubmitButton: isLoading }));
}
